
import { mapActions, mapGetters } from "vuex";
import Logo from "@/assets/images/climat-online-logo.svg";
import LogoEn from "@/assets/images/climat-online-logo-en.svg";
import Arrow from "@/assets/images/arrow-right.svg";
import AppButton from "@/components/Buttons/AppButton.vue";

export default {
  name: "ClimateOnlinePayment",
  components: {
    Logo,
    LogoEn,
    Arrow,
    AppButton,
  },
  props: {
    landingUrl: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    servicePrice: '',
    serviceCurrency: '',
  }),
  computed: {
    ...mapGetters({
      getTranslations: "localization/getTranslations",
      getLang: "localization/getLang",
      // panelDeviceId: "system/getPanelDeviceId",
    }),
  },
  mounted() {
    this.getClimateOnlinePrice(
      {
        deviceId: this.id,
        onClose: () => {
          this.$modal.hide('climateOnlineModal');
        },
      },
    )
      .then(price => {
        this.servicePrice = price.price;
        this.serviceCurrency = price.currency;
      });
  },
  methods: {
    ...mapActions({
      getClimateOnlinePrice: "deviceFunctions/getClimateOnlinePrice",
    }),
    onAboutClick() {
      window.location.href = this.landingUrl;
    },
  },
};
